<template>
  <v-container>
    <!-- Error alert -->
    <v-alert v-if="error" type="error"
      >Your request to reset your password has expired or the link has already
      been used. Please try resetting your password again.</v-alert
    >

    <!-- Success alert -->
    <v-alert v-if="success" type="success"
      >Your password was successfully changed. Click
      <router-link to="/">here</router-link> to return to the homepage.</v-alert
    >

    <!-- Form -->
    <v-row class="mt-3" justify="center">
      <v-card max-width="500" v-if="showForm">
        <v-card-title>Reset password</v-card-title>
        <v-card-text>
          <v-form ref="passwordResetForm" v-model="valid">
            <p>
              You are changing the password for the account associated with the
              email {{ email }}.
            </p>
            <v-text-field
              v-model="password"
              prepend-icon="mdi-lock"
              name="password"
              label="Password"
              type="password"
              required
              :error="passwordError"
              :error-messages="passwordErrorMessages"
              :rules="passwordRules"
              @input="resetState"
            ></v-text-field>
            <v-text-field
              v-model="repeatPassword"
              prepend-icon="mdi-lock"
              name="repeatPassword"
              label="Repeat password"
              type="password"
              required
              :error="passwordError"
              :error-messages="passwordErrorMessages"
              :rules="passwordRules"
              @input="resetState"
              @keydown.enter.stop="submitReset"
            ></v-text-field>
            <v-btn
              class="mt-3"
              color="accent"
              :disabled="!valid"
              :loading="btnLoading"
              @click="submitReset"
              >Submit</v-btn
            >
          </v-form>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import firebase from "@/firebase";
const auth = firebase.auth();

export default {
  data: () => ({
    error: false,
    success: false,
    showForm: false,
    valid: false,
    btnLoading: false,
    email: "",
    actionCode: "",
    password: "",
    repeatPassword: "",
    passwordRules: [
      v => !!v || "The password field cannot be empty",
      v => v.length >= 6 || "The password needs to be longer than 6 characters"
    ],
    passwordError: false,
    passwordErrorMessages: ""
  }),
  async created() {
    this.actionCode = this.$route.query.oobCode;

    try {
      this.email = await auth.verifyPasswordResetCode(this.actionCode);
      this.showForm = true;
    } catch (e) {
      this.error = true;
    }
  },
  methods: {
    async submitReset() {
      if (this.$refs.passwordResetForm.validate() && this.passwordsMatch()) {
        this.btnLoading = true;
        try {
          await auth.confirmPasswordReset(this.actionCode, this.password);
          this.success = true;
        } catch (e) {
          this.error = true;
        }
        this.showForm = false;
        this.btnLoading = false;
      }
    },
    passwordsMatch() {
      if (this.password === this.repeatPassword) {
        return true;
      } else {
        this.passwordError = true;
        this.passwordErrorMessages = "The passwords do not match.";
        return false;
      }
    },
    resetState() {
      this.passwordError = false;
      this.passwordErrorMessages = "";
    }
  }
};
</script>
